export default {
  SET_STOCK(state, res) {
    state.stocks = res.items
    state.totalDataRow = res.totalCount;
  },
  SAVE_STOCK(state, updatedStocks) {
    for (var i = 0; i < updatedStocks.length; i++) {
      let stockIndex = state.stocks.findIndex((p) => p.id == updatedStocks[i].id);
      if (stockIndex >= 0) {
        state.stocks[stockIndex].totalQuantity = updatedStocks[i].totalQuantity;
        state.stocks[stockIndex].rawMaterial.buyPrice = updatedStocks[i].rawMaterial.buyPrice;
      }
    }
  },
  REMOVE_STOCK(state, stockId) {
    const stockIndex = state.stocks.findIndex((p) => p.id == stockId)
    state.stocks.splice(stockIndex, 1)
  },
}
